import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Page, SubPage, Vendor} from '@entities/left-panel/left-panel.interface';
import {MasterContentSync} from '@entities/master-content/episode-view';
import {DataStorageHelper} from 'amc-common-components';
import {Store} from '@ngrx/store';
import {AppState} from '@store';
import {leftPanelSelector} from '@store/left-panel/selectors';
import {Observable} from 'rxjs';

/**
 * Header container.
 * @class
 */
@Component({
	selector: 'mdm-header',
	template: `
		<mdm-header-component
			[selectedPage]="selectedPage$ | async"
			[selectedSubPage]="selectedSubPage$ | async"
			[selectedVendor]="selectedVendor$ | async"
			[userName]="userName"
		>
			<ng-content></ng-content>
		</mdm-header-component>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderContainer {
	/**
	 * Auxiliary variable for accessing to Observable of selected page.
	 */
	public readonly selectedPage$: Observable<Page>;
	/**
	 * Auxiliary variable for accessing to Observable of selected sub page.
	 */
	public readonly selectedSubPage$: Observable<SubPage>;
	/**
	 * Auxiliary variable for accessing to Observable of selected vendor.
	 */
	public readonly selectedVendor$: Observable<Vendor>;
	/** Auxiliary 'userName' variable. */
	public readonly userName: string;

	/**
	 * Constructor for HeaderContainer.
	 */
	constructor(private store: Store<AppState>) {
		this.selectedPage$ = this.store.select(leftPanelSelector.activePage);
		this.selectedSubPage$ = this.store.select(leftPanelSelector.activeSubPage);
		this.selectedVendor$ = this.store.select(leftPanelSelector.activeVendor);
		this.userName = DataStorageHelper.getLocal(DataStorageHelper.SHARED_KEYS.USER_NAME);
	}
}
